<template>
  <main id="operator" class="page-container" v-if="$route.name === 'operators'">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <div class="table-container-clients">
      <div class="clients-toolbar">
        <router-link to="/home/operators/add-operator" class="primary-btn">
          + Nuovo operatore
        </router-link>
      </div>

      <div class="tbl-wrap">
        <table class="tbl client-table">
          <thead>
            <tr>
              <th id="nome-operatore">Nome operatore</th>
              <th id="numero-eventi">Eventi</th>
              <th id="data-ultimo-evento">Ultimo evento</th>
              <th id="stato">Stato</th>
              <th id="documenti">Documenti</th>
              <th class="actions-col"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(op, index) in filteredOperators" :key="index">
              <tr class="client-row">
                <td>{{ op.operatorName }}</td>
                <td>{{ op.numEvents }}</td>
                <td>{{ formatToLocalDate(op.lastEvent) }}</td>
                <td class="status-container">
                  <div class="status-wrapper">
                    <svg
                      :class="[
                        'status-icon',
                        { available: op.state === 'Libero' },
                        { permit: op.state === 'Ferie' },
                        { busy: op.state === 'Occupato' },
                      ]"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                    >
                      <path
                        d="M15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5Z"
                      />
                    </svg>
                    <select
                      :value="op.state"
                      @change="promptStateChange(op, $event.target.value)"
                    >
                      <option value="Occupato">Occupato</option>
                      <option value="Ferie">Ferie</option>
                      <option value="Libero">Libero</option>
                    </select>
                  </div>
                </td>
                <td class="docs-col">
                  <span
                    v-if="op.documents && op.documents.length > 0"
                    class="open-docs-link"
                    @click="openOperatorDocModal(op)"
                  >
                    <font-awesome-icon :icon="['fas', 'file']" />
                    Apri Documenti
                  </span>
                  <span v-else class="docs-none">Non esistono Documenti</span>
                </td>
                <td class="actions-cell">
                  <button
                    class="icons-button"
                    @click="uploadOperatorDoc(op.id)"
                    title="Carica documento"
                    aria-label="Carica documento"
                  >
                    <font-awesome-icon :icon="['fas', 'file-arrow-up']" />
                  </button>
                  <button
                    class="icons-button"
                    @click="goToEditOperator(op.id)"
                    title="Modifica operatore"
                    aria-label="Modifica operatore"
                  >
                    <font-awesome-icon :icon="['fas', 'pen-to-square']" />
                  </button>
                  <button
                    class="icons-button"
                    @click="promptArchive(op)"
                    title="Archivia operatore"
                    aria-label="Archivia operatore"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-can']" />
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <!-- ▸ MODALE ARCHIVIAZIONE OPERATORE -->
    <div v-if="showArchiveModal" class="modal-overlay">
      <div class="modal">
        <button
          class="modal__close icons-button"
          @click="cancelArchive"
          title="Chiudi"
          aria-label="Chiudi"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
        <h3 class="modal__title">Archivia operatore</h3>
        <p class="modal__subtitle">
          Sei sicuro di voler archiviare l'operatore
          <strong>{{ selectedOperator.operatorName }}</strong
          >?
        </p>
        <div class="modal-actions">
          <button class="primary-btn" @click="confirmArchive">Archivia</button>
          <!-- <button class="secondary-btn" @click="cancelArchive">Annulla</button> -->
        </div>
      </div>
    </div>

    <!-- ▸ MODALE CAMBIO STATO -->
    <div v-if="showStateModal" class="modal-overlay">
      <div class="modal">
        <button
          class="modal__close icons-button"
          @click="cancelStateChange"
          title="Chiudi"
          aria-label="Chiudi"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
        <h3 class="modal__title">Cambio stato</h3>
        <p class="modal__subtitle">
          Vuoi confermare il cambio di stato dell'operatore
          <strong>{{ selectedOperator.operatorName }}</strong>
          da <strong>{{ currentState }}</strong> a
          <strong>{{ newState }}</strong
          >?
        </p>
        <div class="modal-actions">
          <button class="primary-btn" @click="confirmStateChange">
            Conferma
          </button>
          <!-- <button class="secondary-btn" @click="cancelStateChange">
            Annulla
          </button> -->
        </div>
      </div>
    </div>

    <!-- ▸ MODALE DOCUMENTI OPERATORE -->
    <VueFinalModal
      v-model="showOperatorDocModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="documents-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="closeOperatorDocModal"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>

        <h3 class="modal__title">
          Documenti —
          {{ selectedOperatorForDocs?.operatorName }}
        </h3>
        <hr class="modal-hr" />

        <div class="operator-docs-list">
          <div
            v-if="
              !selectedOperatorForDocs?.documents ||
              selectedOperatorForDocs.documents.length === 0
            "
            class="operator-docs-empty"
          >
            Nessun documento caricato.
          </div>

          <div
            v-for="doc in selectedOperatorForDocs?.documents"
            :key="doc.name"
            class="doc-row"
          >
            <a
              :href="doc.url"
              :target="isWordDoc(doc.name) ? null : '_blank'"
              :download="isWordDoc(doc.name) ? doc.name : null"
              class="card-link"
            >
              <div class="card-icon">
                <font-awesome-icon
                  :icon="['fas', isWordDoc(doc.name) ? 'file' : 'file-pdf']"
                  size="2x"
                />
              </div>
              <div class="card-body">
                <div class="card-title">{{ formatDocName(doc.name) }}</div>
              </div>
            </a>
            <button
              class="delete-doc-btn"
              title="Elimina documento"
              @click="deleteOperatorDoc(doc)"
            >
              <font-awesome-icon :icon="['fas', 'trash-can']" />
            </button>
          </div>
        </div>
      </template>
    </VueFinalModal>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate } from "../utilities/formatting";
import { useToast } from "vue-toast-notification";
import { VueFinalModal } from "vue-final-modal";

export default {
  setup() {
    const toast = useToast();
    return {
      toast,
    };
  },
  components: {
    VueFinalModal,
  },
  computed: {
    ...mapGetters({
      allOperators: "operators/list",
    }),
    filteredOperators() {
      return this.allOperators.filter((op) => !op.isAdmin);
    },
    selectedOperatorForDocs() {
      if (!this.selectedOperatorIdForDocs) return null;
      return (
        this.allOperators.find(
          (op) => op.id === this.selectedOperatorIdForDocs
        ) || null
      );
    },
  },
  data() {
    return {
      // errorMessage: "",
      // successMessage: "",
      showArchiveModal: false,
      showStateModal: false,
      selectedOperatorId: null,
      selectedOperator: null,
      currentState: null,
      newState: null,
      showOperatorDocModal: false,
      selectedOperatorIdForDocs: null,
    };
  },
  methods: {
    ...mapActions(["fetchOperators", "archiveOperator"]),
    formatToLocalDate,
    async getOperators() {
      try {
        await this.fetchOperators();
      } catch (error) {
        // this.errorMessage =
        this.toast.error(
          error?.response?.data?.details ||
            "Errore durante la visualizzazione degli operatori."
        );
      }
    },
    // Apri modale archiviazione
    promptArchive(operator) {
      this.selectedOperatorId = operator.id;
      this.selectedOperator = operator;
      this.showArchiveModal = true;
    },

    // Conferma archiviazione
    async confirmArchive() {
      try {
        const response = await this.archiveOperator(this.selectedOperatorId);
        if (response.status === 200) {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Operatore archiviato con successo."
          );
        }
      } catch (err) {
        // console.error(err);
        // this.errorMessage =
        this.toast.error(
          err.response?.data?.details ||
            err.response?.data?.error ||
            "Impossibile archiviare l'operatore."
        );
      } finally {
        this.showArchiveModal = false;
        this.selectedOperatorId = null;
        this.getOperators();
      }
    },

    cancelArchive() {
      this.showArchiveModal = false;
      this.selectedOperatorId = null;
    },

    // Cambio stato
    promptStateChange(operator, state) {
      this.selectedOperatorId = operator.id;
      this.selectedOperator = operator;
      this.currentState = operator.state;
      this.newState = state;
      this.showStateModal = true;
    },

    async confirmStateChange() {
      try {
        const payload = JSON.stringify({ state: this.newState });
        const response = await this.$axios.patch(
          `auth/state/${this.selectedOperatorId}`,
          payload
        );
        if (response.status === 200) {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Stato aggiornato con successo."
          );
        }
      } catch (err) {
        // this.errorMessage =
        this.toast.error(
          err.response?.data?.details ||
            err.response?.data?.error ||
            "Errore nell'aggiornamento dello stato."
        );
      } finally {
        this.showStateModal = false;
        this.selectedOperatorId = null;
        this.getOperators();
      }
    },

    cancelStateChange() {
      this.showStateModal = false;
      this.selectedOperatorId = null;
      this.getOperators();
    },
    // async updateOperatorState(operatorId, newState) {
    //   try {
    //     const conferma = window.confirm(
    //       "Sei sicuro di voler cambiare lo stato dell'operatore?"
    //     );
    //     if (!conferma) {
    //       this.getOperators();
    //       return;
    //     }

    //     const payload = JSON.stringify({ state: newState });
    //     const response = await this.$axios.patch(
    //       `auth/state/${operatorId}`,
    //       payload
    //     );

    //     if (response.status === 200) {
    //       this.successMessage =
    //         response.data.message || "Stato aggiornato con successo.";
    //     }
    //   } catch (error) {
    //     this.errorMessage =
    //       error?.response?.data?.message ||
    //       "Errore durante l'aggiornamento dello stato dell'operatore.";
    //   }
    // },
    goToEditOperator(operatorId) {
      this.$router.push({ name: "edit-operator", params: { operatorId } });
    },

    formatDocName(name) {
      if (!name) return "";
      return name.replace(/_/g, " ").replace(/\.[^.]+$/, "");
    },

    isWordDoc(name) {
      if (!name) return false;
      const ext = name.split(".").pop().toLowerCase();
      return ext === "doc" || ext === "docx";
    },

    openOperatorDocModal(operator) {
      this.selectedOperatorIdForDocs = operator.id;
      this.showOperatorDocModal = true;
    },

    closeOperatorDocModal() {
      this.showOperatorDocModal = false;
      this.selectedOperatorIdForDocs = null;
    },

    async uploadOperatorDoc(operatorId) {
      const id = operatorId ?? this.selectedOperatorForDocs?.id;
      if (!id) return;

      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".pdf,.doc,.docx";

      const file = await new Promise((resolve) => {
        input.onchange = () => resolve(input.files[0]);
        input.click();
      });

      if (!file) return;

      const ext = file.name.split(".").pop().toLowerCase();
      if (!["pdf", "doc", "docx"].includes(ext)) {
        this.toast.info("Puoi caricare solo file PDF o Word (.doc, .docx).");
        return;
      }

      this.toast.info("Caricamento in corso...");

      try {
        await this.$store.dispatch("uploadOperatorDocument", {
          operatorId: id,
          document: file,
          filename: file.name,
        });
        this.toast.success("Documento caricato con successo.");
      } catch (error) {
        this.toast.error(
          error.response?.data?.error ||
            "Errore durante il caricamento del documento."
        );
      }
    },

    async deleteOperatorDoc(doc) {
      if (!this.selectedOperatorForDocs || !doc) return;

      try {
        await this.$store.dispatch("deleteOperatorDocument", {
          operatorId: this.selectedOperatorForDocs.id,
          objectName: doc.name,
        });
        this.toast.success("Documento eliminato.");
      } catch (err) {
        this.toast.error(
          err.response?.data?.error || "Impossibile eliminare il documento."
        );
      }
    },
    // async onArchiveOperator(operatorId) {
    //   const conferma = window.confirm(
    //     "Sei sicuro di voler archiviare l'operatore?"
    //   );
    //   if (!conferma) return;

    //   try {
    //     await this.archiveOperator(operatorId);
    //     this.successMessage = "Operatore archiviato con successo.";
    //     this.getOperators();
    //   } catch (err) {
    //     console.error(err);
    //     this.errorMessage = "Impossibile archiviare l'operatore.";
    //   }
    // },
  },
  mounted() {
    this.getOperators();
  },
};
</script>

<style src="../css/OperatorPage.css" />
